import { useState } from "react";
import "./HappyGuarantee.css";
import { FaStar } from "react-icons/fa";

const HappyGuarantee = ({ data }: { data: any }) => {
  const [index, setIndex] = useState(0);
  const current = data?.testimonials[index];

  const handlePrev = () => {
    setIndex(index === 0 ? data?.testimonials.length - 1 : index - 1);
  };

  const handleNext = () => {
    setIndex(index === data?.testimonials.length - 1 ? 0 : index + 1);
  };

  return (
    <section className="happy-wrapper max-w-screen-xl mx-auto py-10">
      <h2 className="happy-heading">{data?.header}</h2>
      {/* <h3 className="happy-description">{data?.description}</h3> */}
      <div className="top-row">
        <div className="stars-row">
          {Array(data?.rating)
            .fill(0)
            .map((_, i) => (
              <FaStar key={i} color="#FFA500" />
            ))}
        </div>
        <p className="happy-customers">{data?.totalCustomersText}</p>
      </div>

      <div className="carousel">
        <button className="nav-arrow" onClick={handlePrev}>
          &#8592;
        </button>

        <div className="slide-content">
          <div className="left-image">
            <img src={current.leftImage} alt="product" />
          </div>

          <div
            className="right-card"
            style={{
              backgroundImage: `url(${current.backgroundImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div className="card-content">
              <div className="stars">
                {Array(current.rating)
                  .fill(0)
                  .map((_, i) => (
                    <FaStar key={i} color="#FFA500" />
                  ))}
              </div>
              {/* <h3>{current.title}</h3> */}
              <p className="review">{current.review}</p>
              <div className="customer">
                {/* <img
                  src={current.customerPhoto}
                  className="customer-photo"
                  alt="profile"
                /> */}
                <div>
                  <div className="name">{current.customerName}</div>
                  <div className="platform">{current.platform}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button className="nav-arrow" onClick={handleNext}>
          &#8594;
        </button>
      </div>

      <div className="dots">
        <span className="dot" />
        <span className="dot active" />
        <span className="dot" />
      </div>
      {/* <section className="max-w-5xl mx-auto my-12 px-4 py-10">
        <div className="flex flex-col bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-200">
       
          <div className="p-8 md:p-10 flex flex-col gap-4 md:gap-5">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#1a1423] leading-tight">
              Welcome to the{" "}
              <span className="text-[#861528]">We Must Club</span>
          </h2>
            <p className="text-sm md:text-base lg:text-lg text-gray-700 leading-relaxed">
              The We Must Club is our loyalty program designed to reward our
              partners on every order. Earn cashback on future jobs, unlock
              rush-order benefits, and lower your free-shipping threshold as
              your monthly spend grows.
          </p>

            <div className="bg-[#ffeeda] border-l-4 border-[#fbc02d] rounded-r-xl py-3 md:py-4 px-4 md:px-5">
              <p className="text-xs md:text-sm lg:text-base text-[#4b2e05] leading-relaxed">
                Tiers start at{" "}
                <strong className="text-[#861528]">2% cashback</strong> for
                members spending{" "}
                <strong className="text-[#861528]">$1,000–$2,500</strong> per
                month — with higher tiers earning up to{" "}
                <strong className="text-[#861528]">12% back</strong> plus{" "}
                <strong className="text-[#861528]">
                  rush orders with no additional fee
                </strong>
                .
              </p>
            </div>

            <p className="text-xs md:text-sm text-gray-600 italic">
              It's our way of giving back to the partners who grow with us and
              helping you maximize value on every single order.
            </p>
          </div>


          <div className="w-full">
            <img
              src="https://wemust-nest.s3.ca-central-1.amazonaws.com/1766587023049_Cash_Back_Flyer_Back.jpeg"
              alt="We Must Club benefits"
              className="w-full h-auto object-cover"
            />
          </div>
        </div>
      </section> */}

      {/* Bulk Discount Section */}
       {/* <section className="max-w-5xl mx-auto mb-12 px-4 py-10">
        <div className="text-center mb-6">
          <h2 className="text-2xl md:text-3xl font-bold text-[#1a1423]">
            Pricing That Rewards Volume
          </h2>
          <p className="mt-3 text-sm md:text-base text-gray-700 max-w-3xl mx-auto leading-relaxed">
            We Must offers volume-based discounts designed to support growing order sizes
            and repeat production. As your quantities increase, your cost per unit
            decreases—helping you improve margins while maintaining the same premium
            quality and fast turnaround.
          </p>
        </div>

        <div className="bg-[#861528] rounded-xl p-[2px] shadow-lg">
          <div className="flex flex-col md:flex-row">
           
            <div className="flex-1 bg-black text-white px-6 py-6 md:py-8 text-center border-b md:border-b-0 md:border-r border-[#861528]">
              <p className="text-xl md:text-2xl font-extrabold tracking-wide">
                10% OFF
              </p>
              <p className="mt-1 text-sm md:text-base font-semibold">
                ORDERS OVER $300
              </p>
              <p className="mt-3 text-xs md:text-sm uppercase tracking-[0.18em] text-[#f9c67a]">
                Use Code: <span className="font-bold">BULK10</span>
              </p>
            </div>

         
            <div className="flex-1 bg-black text-white px-6 py-6 md:py-8 text-center">
              <p className="text-xl md:text-2xl font-extrabold tracking-wide">
               ADDITIONAL 5% OFF
              </p>
              <p className="mt-1 text-sm md:text-base font-semibold">
                ORDERS OVER $750
              </p>
              <p className="mt-3 text-xs md:text-sm uppercase tracking-[0.18em] text-[#f9c67a]">
                Use Code: <span className="font-bold">BIGBULK5</span>
              </p>
            </div>
          </div>
        </div>

        <p className="mt-3 text-center text-xs md:text-sm text-[#1a1423] font-medium">
          <span role="img" aria-label="truck">
            🚚
          </span>{" "}
          *Free Shipping on Orders Over <strong>$175</strong>
        </p>
      </section>  */}
 
    </section>
  
  );
};

export default HappyGuarantee;
